<template>
    <md-dialog id="multi_org_modal" :md-active.sync="open" class="multi-org-modal">
      <md-dialog-title class="modal-title">
        Edit user organizations
      </md-dialog-title>
      
      <md-dialog-content class="modal-body">
        <div style="padding: 0 0 24px 0;">Select organizations for: <b>{{ userName }}</b></div>
        <md-field class="modal-field">
          <label for="specialization" class="modal-label">Organizations</label>
          <md-select
            v-validate="'required'"
            v-model="selectedOrgs"
            name="shopId"
            multiple
            class="modal-select"
          >
            <md-option v-for="item in organizationsList" :key="item.id" :value="item.id">
              {{ item.businessName }}
            </md-option>
          </md-select>
        </md-field>
      </md-dialog-content>
      <md-dialog-actions style="justify-content: center;margin-bottom: 1rem;">
        <md-button style="width: 130px;background-color: white !important;box-shadow: none;color: #000 !important;" @click="close">Cancel</md-button>
        <md-button
          class="md-primary"
          :disabled="!validate || isLoading || selectedOrgs.length === 0"
          style="width: 130px;"
          @click="save"
        >
          Save
        </md-button>
      </md-dialog-actions>
    </md-dialog>
</template>

<script>
import Swal from "sweetalert2"
import { mapActions, mapGetters } from "vuex"

export default {
  name: "SelectMultipleOrgModal",
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    selectedUser: {
      type: Object,
      default: () => ({})
    },
    userType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      open: false,
      isLoading: false,
      organizations: [],
      selectedOrgs: []
    }
  },
  computed: {
    ...mapGetters(["organizationsList"]),
    userName() {
      switch (this.userType) {
        case "technicians":
          return `${this.selectedUser.person.firstName} ${this.selectedUser.person.lastName}`
        case "readers":
          return `${this.selectedUser.personal.firstName} ${this.selectedUser.personal.lastName}`
        case "admins":
          return `${this.selectedUser.person.firstName} ${this.selectedUser.person.lastName}`
        case "doctors":
          return `${this.selectedUser.Personal.firstName} ${this.selectedUser.Personal.lastName}`
        default:
          return ""
      }
    },
    targetId() {
      switch (this.userType) {
        case "technicians":
        case "admins":
          return this.selectedUser.ID
        case "readers":
          return this.selectedUser.editInfo.doctorID
        case "doctors":
          return this.selectedUser.EditInfo.id
        default:
          return ""
      }
    }
  },
  created() {
    this.fetchOrgs()
  },
  watch: {
    selectedUser: {
      handler(newVal) {
        if (newVal) {
          switch (this.userType) {
            case "technicians":
              this.selectedOrgs = this.normalizeOrgs(newVal.organisations)
              break
            case "readers":
              this.selectedOrgs = this.normalizeOrgs(newVal.editInfo.organisations)
              break
            case "admins":
              this.selectedOrgs = this.normalizeOrgs(newVal.organisations)
              break
            case "doctors":
              this.selectedOrgs = this.normalizeOrgs(newVal.EditInfo.organisations)
              break
          }
        }
      },
      immediate: true
    },
    isOpen: {
      handler(newVal) {
        if (newVal) {
          this.open = newVal
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(["listOrganizations", "updateUserOrganizations"]),
    async fetchOrgs() {
      await this.listOrganizations()
    },

    close() {
      this.$emit("close")
    },
    validate() {
      if (this.selectedOrgs.length === 0) {
        return false
      } else {
        return this.$validator.validateAll().then((res) => {
          return res
        })
      }
    },
    normalizeOrgs(orgs) {
      if (typeof orgs == "string") {
        if (orgs.includes(",")) {
          return orgs.split(",").map((org) => org.trim())
        } else {
          return [orgs]
        }
      } else if (Array.isArray(orgs)) return orgs
    },

    async save() {
      this.isLoading = true
      try {
        await this.updateUserOrganizations({
          userType: this.userType.slice(0, -1), // remove the plural 's' from the userType so it conforms with Database
          organizations: this.selectedOrgs,
          targetUserId: this.targetId
        })
        Swal.fire({
          title: "Success",
          text: "Organizations updated successfully.",
          showConfirmButton: false,
          timer: 1500
        })
        this.close()
      } catch (error) {
        console.error("Error updating organizations:", error)
        Swal.fire({
          title: "Error",
          text: "Failed to update organizations.",
          showConfirmButton: false,
          timer: 1500
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
</style>

